module.exports = __webpack_public_path__ + "static/media/LowFiWireframes.20c6d466.pdf";